module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0089.jpg?v=1bfbff3e";